/**
 * 应用主入口文件
 * 初始化Vue应用并挂载到DOM
 */
import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';
import './styles/main.scss';
const app = createApp(App);
app.use(createPinia());
app.use(router);
app.mount('#app');
